module.exports = __webpack_public_path__ + "img/man.cc8019f3.png";